import { render, staticRenderFns } from "./display-field-switch.vue?vue&type=template&id=06c87b2c&scoped=true&"
import script from "./display-field-switch.ts?vue&type=script&lang=ts&"
export * from "./display-field-switch.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-switch.scss?vue&type=style&index=0&id=06c87b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c87b2c",
  null
  
)

export default component.exports